
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import MylobyAutocompleteMultiple from "@/components/generic/autocomplete-multiple.vue";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";
import { SCOPED_GROUP_PREFIX } from "@/utils/constants";

@Component({
  components: {
    MylobyAutocompleteMultiple,
    MylobyAutocomplete,
  },
})
export default class KeyGroupEdit extends Vue {
    @Prop({default: null})
    public group: {
        id: number,
        name: string,
        description: string,
        companyId: number,
        buildingId: number,
        scope: string | null,
    };

    private displayEditKeyGroupDialog: boolean = true;
    private updateInProgress: boolean = false;
    private hasDifferentBuildingIds: boolean = true;
    private scoped: boolean = false;
    private commonBuildingId: number = null;
    private SCOPED_GROUP_PREFIX = SCOPED_GROUP_PREFIX;

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    private async mounted() {
        const [keys, nonTransferables] = await Promise.all([
            this.getKeys(),
            this.getNonTransferables(),
        ]);
        this.scoped = this.group.name.includes(SCOPED_GROUP_PREFIX);
        this.group.name = this.group.name
        .replace(SCOPED_GROUP_PREFIX, "");

        // si les objets ont des buildingId différents ou nuls, ne pas afficher l'autocomplete bâtiment
        const allItems = [...keys, ...nonTransferables];
        if (allItems.length) {
          const firstId = allItems[0].buildingId;
          this.hasDifferentBuildingIds = allItems.some((item) => !item.buildingId || item.buildingId !== firstId);
          this.commonBuildingId = this.hasDifferentBuildingIds ? null : firstId;
        }
    }

    private async updateKeyGroup(): Promise<void> {
        this.updateInProgress = true;
        await this.$store.dispatch("keyGroups/update", {
            id: this.group.id,
            data: {
              name: this.scoped ? SCOPED_GROUP_PREFIX + this.group.name : this.group.name,
              description: this.group.description,
              buildingId: this.group.buildingId,
            },
        })
        .then(() => {
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n.t("actions.saved"),
            });
            this.$emit("reset");
            this.$emit("close");
        })
        .catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        })
        .finally(() => {
            this.updateInProgress = false;
        });
    }

    private async getKeys(): Promise<any[]> {
        return this.$store.dispatch("keyGroups/getKeysInGroup", {
            id: this.group.id,
            params: {
                select: [],
                page: 1,
                itemsPerPage: 25,
                search: "",
            },
        }).then((res) => res.rows );
    }

    private async getNonTransferables(): Promise<any[]> {
        return this.$store.dispatch("keyGroups/getNonTransferables", {
            id: this.group?.id,
        }).then((res) => res.rows );
    }

    private closeEdit() {
        this.$emit("close");
    }
}
